export const SEARCH_START = 'SEARCH_START';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const CHANGED_ACCOUNTS_START = 'CHANGED_ACCOUNTS_START';
export const CHANGED_ACCOUNTS_SUCCESS = 'CHANGED_ACCOUNTS_SUCCESS';
export const CHANGED_ACCOUNTS_FAILURE = 'CHANGED_ACCOUNTS_FAILURE';

export const ADDED_ACCOUNTS_START = 'ADDED_ACCOUNTS_START';
export const ADDED_ACCOUNTS_SUCCESS = 'ADDED_ACCOUNTS_SUCCESS';
export const ADDED_ACCOUNTS_FAILURE = 'ADDED_ACCOUNTS_FAILURE';

export const DELETED_ACCOUNTS_START = 'DELETED_ACCOUNTS_START';
export const DELETED_ACCOUNTS_SUCCESS = 'DELETED_ACCOUNTS_SUCCESS';
export const DELETED_ACCOUNTS_FAILURE = 'DELETED_ACCOUNTS_FAILURE';

export const CSV_OUTPUT_START = 'CSV_OUTPUT_START';
export const CSV_OUTPUT_SUCCESS = 'CSV_OUTPUT_SUCCESS';
export const CSV_OUTPUT_FAILURE = 'CSV_OUTPUT_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
